/* eslint-disable no-underscore-dangle */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import {
  addPickUpPerson,
  openForm,
  showErrorMessage,
  resetState,
} from './AddPickUpPersonForm.actions';
import { getOrderDetailsDataState } from '../../../container/OrderDetails.selectors';
import {
  getAddPickUpErrorState,
  getErrorMessage,
  getFormState,
  getLoaderState,
  getModalData,
  getShowErrorMessage,
  isShowSuccessMessage,
} from './AddPickUpPersonForm.selectors';
import { getAltPersonLimit } from '../../../../../../../reduxStore/selectors/session.selectors';
import { getOrdersState } from '../../../../Orders/container/Orders.selectors';
import AddPickUpPersonFormView from '../views';
import { selectOrder } from '../../../../CustomerHelp/container/CustomerHelp.actions';

const AddPickUpPersonFormContainer = (props) => {
  return <AddPickUpPersonFormView {...props} />;
};
const mapStateToProps = (state) => {
  return {
    orderDetailsData: getOrderDetailsDataState(state),
    errorState: getAddPickUpErrorState(state),
    errorMessage: getErrorMessage(state),
    showErrorMessageState: getShowErrorMessage(state),
    loader: getLoaderState(state),
    altPickupPersonLimit: getAltPersonLimit(state),
    ordersList: getOrdersState(state),
    formState: getFormState(state),
    addPickUpModalData: getModalData(state),
    isShowSuccessMessageState: isShowSuccessMessage(state),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  openFormAction: (payload) => {
    dispatch(openForm(payload));
  },
  addPickUpPersonAction: (payload) => dispatch(addPickUpPerson(payload)),
  showErrorMessageAction: (payload) => dispatch(showErrorMessage(payload)),
  selectOrderAction: (payload) => {
    dispatch(selectOrder(payload));
  },
  resetStateAction: () => {
    dispatch(resetState());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPickUpPersonFormContainer);
